import { useEffect } from 'react';
import { DrawLine } from './DrawLine';
import { Button, Modal, Box, Typography, Grid, List } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import CloseIcon from '@mui/icons-material/Close';

interface SidebarProps {
  showModal: boolean;
  setShowModal?: any;
}

export default function Sidebar(props: SidebarProps) {
  const { showModal, setShowModal } = props;

  const handleClickThumbUpIcon = () => {
    console.log('ThumbUp is clicked');
  };

  const handleClickThumbDownIcon = () => {
    console.log('ThumbDown is clicked');
  };

  useEffect(() => {
    // call click outside
  }, []);

  return (
    <div className={showModal ? 'modal-dialog show' : 'modal-dialog'} role='document'>
      <div className='modal-content'>
        <div className='modal-header'></div>

        <div className='modal-body'>
          <Grid container textAlign={'right'} alignItems={'right'} style={{ marginTop: '10px', marginRight: '20px' }}>
            <Grid item xs={4} textAlign={'left'} alignItems={'left'}>
              Filter
            </Grid>
            <Grid item xs={4}></Grid>
            <Grid item xs={4} textAlign={'right'} alignItems={'right'}>
              <button
                type='button'
                className='close'
                data-dismiss='modal'
                aria-label='Close'
                onClick={() => {
                  setShowModal(false);
                }}
              >
                <span aria-hidden='true'>&times;</span>
              </button>
            </Grid>
          </Grid>

          <DrawLine color={'black'} />

          <Grid container textAlign={'center'} alignItems={'center'} style={{ marginTop: '10px' }}>
            <Grid item xs={6} textAlign={'center'} alignItems={'center'}>
              <Typography gutterBottom variant='h6' component='div' color='text.primary'>
                Period
              </Typography>
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={6}>
              <Button size={'large'} variant='contained' style={{ width: '80%' }}>
                Last 30 days
              </Button>
            </Grid>

            <Grid item xs={6}>
              <Button size={'large'} variant='contained' style={{ width: '80%' }}>
                Quarter
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button size={'large'} variant='contained' style={{ width: '80%' }}>
                Half Year
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button size={'large'} variant='contained' style={{ width: '80%' }}>
                Full Year
              </Button>
            </Grid>
          </Grid>

          <DrawLine color={'black'} />

          <Grid container textAlign={'center'} alignItems={'center'} style={{ marginTop: '10px' }}>
            <Grid item xs={6} textAlign={'center'} alignItems={'center'}>
              <Typography gutterBottom variant='h6' component='div' color='text.primary'>
                Pin
              </Typography>
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={6}>
              <ThumbUpIcon style={{ height: '40px', width: '40px', cursor: 'pointer' }} onClick={handleClickThumbUpIcon} />
            </Grid>
            <Grid item xs={6}>
              <ThumbDownIcon style={{ height: '40px', width: '40px', cursor: 'pointer' }} onClick={handleClickThumbDownIcon} />
            </Grid>

            <Grid item xs={12}>
              <Button size={'large'} variant='contained' style={{ width: '80%', marginTop: '20px' }}>
                Search
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
}
